import { render, staticRenderFns } from "./passRejectRefuse.vue?vue&type=template&id=604557dd&scoped=true"
import script from "./passRejectRefuse.vue?vue&type=script&lang=js"
export * from "./passRejectRefuse.vue?vue&type=script&lang=js"
import style0 from "./passRejectRefuse.vue?vue&type=style&index=0&id=604557dd&prod&scoped=true&lang=css"
import style1 from "./passRejectRefuse.vue?vue&type=style&index=1&id=604557dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604557dd",
  null
  
)

export default component.exports